import cons from "../../cons.js";
/// La direccion de su contrato acá ///////////////////////////////////
const contractAddress = cons.SC;

export default contractAddress;